import React from 'react';
import { Link } from 'react-router-dom';
import { KPI_ACCENTS } from '../dashboardStatsConfig';
import { getSectionCharts } from '../dashboardChartConfig';
import DashboardChartCard from './charts/DashboardChartCard';

const DashboardKpiCard = ({ label, value, icon, accent, linkTo }) => {
    const content = (
        <>
            <span className="dashboard-kpi-card__icon" aria-hidden="true">
                <i className={`bi ${icon || 'bi-graph-up'}`} />
            </span>
            <span className="dashboard-kpi-card__label">{label}</span>
            <span className="dashboard-kpi-card__value">{value}</span>
            {linkTo && (
                <span className="dashboard-kpi-card__link-hint">
                    <i className="bi bi-arrow-up-right" />
                </span>
            )}
        </>
    );

    if (linkTo) {
        return (
            <Link
                to={linkTo}
                className="dashboard-kpi-card dashboard-kpi-card--colorful"
                style={{ background: accent }}
            >
                {content}
            </Link>
        );
    }

    return (
        <div
            className="dashboard-kpi-card dashboard-kpi-card--colorful"
            style={{ background: accent }}
        >
            {content}
        </div>
    );
};

const DashboardStatTile = ({ label, value }) => (
    <div className="dashboard-stat-tile">
        <span className="dashboard-stat-tile__label">{label}</span>
        <span className="dashboard-stat-tile__value">{value}</span>
    </div>
);

function DashboardSection({ section, getStat, className = '' }) {
    const isKpi = section.variant === 'kpi';
    const charts = isKpi ? [] : getSectionCharts(section.id, getStat);

    return (
        <div
            id={`dashboard-section-${section.id}`}
            className={`ecx-page-card dashboard-section-card ${className}`.trim()}
        >
            <div className="ecx-page-panel__header">
                <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                    <div className="d-flex align-items-center gap-2">
                        <span className="ecx-page-icon-badge">
                            <i className={`bi ${section.icon}`} />
                        </span>
                        <div>
                            <h5 className="mb-0 fw-semibold text-dark">{section.title}</h5>
                            <p className="mb-0 small text-muted">{section.description}</p>
                        </div>
                    </div>
                    {section.linkTo && (
                        <Link to={section.linkTo} className="dashboard-section-link btn btn-sm btn-light-primary rounded-pill">
                            {section.linkLabel || 'Open section'}
                            <i className="bi bi-arrow-right ms-1" />
                        </Link>
                    )}
                </div>
            </div>
            <div className="ecx-page-panel__body">
                {charts.length > 0 && (
                    <div className={`dashboard-section-charts ${isKpi ? '' : 'mb-3'}`}>
                        {charts.map((chart) => (
                            <DashboardChartCard key={chart.id} chart={chart} chartIndex={chart.chartIndex} />
                        ))}
                    </div>
                )}

                {isKpi ? (
                    <div className="dashboard-kpi-grid">
                        {section.stats.map((stat, index) => (
                            <DashboardKpiCard
                                key={stat.key}
                                label={stat.label}
                                value={getStat(stat.key)}
                                icon={stat.icon}
                                accent={KPI_ACCENTS[index % KPI_ACCENTS.length]}
                                linkTo={stat.linkTo}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="dashboard-section-grid">
                        {section.stats.map((stat) => (
                            <DashboardStatTile
                                key={stat.key}
                                label={stat.label}
                                value={getStat(stat.key)}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default DashboardSection;
